import { FC } from "react";

interface MainLayoutProps {
	children: React.ReactNode;
}

const MainLayout: FC<MainLayoutProps> = ({ children }: MainLayoutProps) => {
	return <main className="w-full h-[86vh] bg-lightWhite">{children}</main>;
};

export default MainLayout;
